import { useSessionWarning } from "@/hooks/useSessionWarning";
import { useActivityTracker } from "@/hooks/useActivityTracker";

export function SessionWarning() {
  const { warning, clearWarning } = useSessionWarning();
  const { extendSession } = useActivityTracker();

  if (!warning) return null;

  const isActivityWarning =
    warning.includes("will expire in") && warning.includes("inactivity");
  const isTimeoutWarning = warning.includes("has expired due to inactivity");

  const handleExtendSession = () => {
    extendSession();
    clearWarning();
  };

  return (
    <div
      className={`fixed top-4 right-4 border-l-4 p-4 rounded shadow-lg z-50 max-w-sm ${
        isTimeoutWarning
          ? "bg-red-100 border-red-500 text-red-700"
          : "bg-yellow-100 border-yellow-500 text-yellow-700"
      }`}
    >
      <div className="flex">
        <div className="ml-3">
          <p className="text-sm font-medium">
            {isTimeoutWarning ? "Session Expired" : "Session Notice"}
          </p>
          <p className="text-sm">{warning}</p>
          <div className="mt-2 flex gap-2">
            {isActivityWarning && (
              <button
                onClick={handleExtendSession}
                className="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1 rounded text-xs font-medium"
              >
                Stay Logged In
              </button>
            )}
            <button
              onClick={clearWarning}
              className="bg-gray-300 hover:bg-gray-400 text-gray-700 px-3 py-1 rounded text-xs font-medium"
            >
              Dismiss
            </button>
          </div>
        </div>
        <div className="ml-auto">
          <button
            onClick={clearWarning}
            className={`${
              isTimeoutWarning
                ? "text-red-500 hover:text-red-700"
                : "text-yellow-500 hover:text-yellow-700"
            }`}
          >
            <span className="sr-only">Close</span>
            <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fillRule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}
